var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0M8 8h16c.286 0 .563.061.817.177L16 18.463 7.183 8.176c.254-.116.531-.177.817-.177zM6 22V10q0-.063.004-.125l5.864 6.842-5.8 5.8A2 2 0 0 1 5.999 22zm18 2H8q-.266 0-.517-.069l5.691-5.691L16 21.537l2.826-3.297 5.691 5.691q-.251.068-.517.069m2-2q0 .266-.069.517l-5.8-5.8 5.865-6.842Q26 9.937 26 10z"
  })));
};
export default SvgEmail;